import type { jsPDF } from "jspdf";
import { BaseElement } from "./baseElement";

export class BlockInlineContainer extends BaseElement {
	kind = "block-inline" as const;

	async calculate(jsPdf: jsPDF) {
		const boundingBox = this.box.getBoundingBox();
		let rowHeight = 0;
		let cursorX = boundingBox.x;
		let cursorY = boundingBox.y;
		let totalHeight = 0;
		for (const child of this.children) {
			if (cursorX + child.box.size.width > boundingBox.x + boundingBox.width) {
				cursorX = boundingBox.x;
				cursorY += rowHeight;
				totalHeight += rowHeight;
				rowHeight = 0;
			}
			child.box.position.x = cursorX;
			child.box.position.y = cursorY;
			await child.calculate(jsPdf);
			const childBoundingBox = child.box.getBoundingBox();
			rowHeight = Math.max(rowHeight, childBoundingBox.outerHeight);
			cursorX += childBoundingBox.outerWidth;
		}

		if (rowHeight > totalHeight) {
			totalHeight = rowHeight;
		}
		this.box.size.height = totalHeight;
	}

	override async draw(pdfDocument: jsPDF): Promise<void> {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}
}
